//
// AbstractAnnotation.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../core/RendererModel";
import "./AnnotationDrawSpace";
import "./AnnotationLayer";
import "../axis/XAxisPosition";
import "../axis/YAxisPosition";

var AbstractAnnotation = createModule("gtl::AbstractAnnotation", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel","gtl::RendererModel"], EventDispatcher, [
    ,
    {
        discreteOffset: 5,
        yAxis: 4,
        xAxis: 4,
        drawSpace: 4,
        transparency: 5,
        url: 7,
        layer: 4,
    },
    ,
    ,
    ,
    ,
    ,
]);
export default AbstractAnnotation;
